const digitalHumansRouter = {
  path: '',
  component: () => import('@/layout/footerLayout'),
  children: [
    {
      path: 'digitalhumans',
      name: 'DigitalHumans',
      meta: { title: '数字人宣传页' },
      component: () => import(/* webpackChunkName: "combine" */ '@/pages/digitalHumans')
    },
    {
      path: 'digitalhumans/boss',
      name: 'DigitalHumansBoos',
      meta: { title: '数字人老板娘' },
      component: () => import(/* webpackChunkName: "combine" */ '@/pages/digitalHumans/boss')
    }
  ]
}

export default digitalHumansRouter
